import {
  BulkLoadedType,
  BulkRemoveType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  type QueryParams,
  RequestMoreType,
  RequestType,
} from 'common/actions/ideas';

import queryReducerFactory, { type QueriesState } from './queryReducerFactory';
export { defaultState } from './queryReducerFactory';

import type { Idea } from 'common/api/endpoints/idea';

export type IdeasState = QueriesState<Idea, QueryParams>;

export default queryReducerFactory<Idea, QueryParams>({
  bulkLoadedType: BulkLoadedType,
  bulkRemoveType: BulkRemoveType,
  errorType: ErrorType,
  invalidateType: InvalidateType,
  loadedMoreType: LoadedMoreType,
  loadedType: LoadedType,
  requestMoreType: RequestMoreType,
  requestType: RequestType,
  uniqueKey: '_id',
});
